import { lazy } from 'react';

export const ConfirmationModal = lazy(() => import('./ConfirmationModal'));
